module.exports = __webpack_public_path__ + "img/user-2.52914b19.png";